import { IMultisiteItem } from '@df/core/service/multisite';

export namespace Multisite {
    ////////////////////////////////////////////////////
    ///
    /// EVENTS
    ///
    ////////////////////////////////////////////////////

    /**
     * Before multisite redirection event name
     */
    export const REDIRECT_BEFORE_EVENT = 'multisite_redirect_before';

    /**
     * Before multisite redirection event data
     */
    export interface IRedirectBeforeEvent {
        url?: string;
        next: () => void;
        continue: boolean;
        target: IMultisiteItem;
        options: IEventOptions;
    }

    /**
     * After meta alternates been updated event name
     */
    export const META_ALTERNATE_UPDATE_EVENT = 'meta_alternate_update';

    /**
     * After meta alternates been updated event data
     */
    export interface IMetaAlternateUpdateEvent {}

    ////////////////////////////////////////////////////
    ///
    /// INTERFACES
    ///
    ////////////////////////////////////////////////////

    /**
     * Meta alternates language map
     */
    export interface ILangMap {
        [strore: number]: string[];
    }

    /**
     * Meta alternates load request data
     */
    export interface ILoadAlternateRequest {
        id: number;
        type: string;
        storesIds: number[];
    }

    /**
     * Meta alternates load result data
     */
    export interface ILoadAlternateResult {
        alternates: { store: number; href: string }[];
    }
    /**
     * Options passed with events
     */
    export interface IEventOptions {}
}
